<template>
  <modal-default
    ref="modal"
    title="Link"
    :short-circuit-close="true"
    @close="cancelAndClose"
  >
    <form-field-input
      label="URL"
      v-model="linkUrl"
    ></form-field-input>

    <div class="flex flex-end flex-vertical-center">
      <button-link @click="cancelAndClose">Cancel</button-link>
      <button-default class="ml-100" @click="updateUrl">Set Link</button-default>
    </div>
  </modal-default>
</template>

<script>
import ModalBase from "../../../modal/ModalBase";
import {destroyModal} from "../../../../services/modals";

export default {
  name: "LinkModal",
  components: {ModalBase},
  props: ["url"],
  data() {
    return {
      linkUrl: null
    };
  },
  mounted() {
    this.$refs.modal.open();

    if (this.url && this.url.startsWith("//")) {
      this.url = this.url.substring(2);
    }

    this.linkUrl = this.url;
  },
  methods: {
    updateUrl() {
      this.$emit("updateLink", this.linkUrl);
      destroyModal(this.$refs.modal);
    },
    cancelAndClose() {
      destroyModal(this.$refs.modal);
    }
  }
};
</script>
